import { ServiceFunction } from "utils/index";
import BaseService from "../base";
import { ICurrentProcedureHistoryResponse } from "./types";

class ChangeHistoryService extends BaseService {
  getCurrentProcedureHistory: ServiceFunction<any, ICurrentProcedureHistoryResponse> = (
    para,
    success,
    error
  ) => {
    // @ts-ignore
    this.sendRequest("getCurrentProcedureHistory", para, success, error);
  };

  getAllProcedureHistory = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getAllProcedureHistory", para, success, error);
  };

  getTaskHistory = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getTaskHistory", para, success, error);
  };

  getCategoryList = (para: any, success: any, error: any, returnPara: any) => {
    // @ts-ignore
    this.sendRequest("getCategoryList", para, success, error, returnPara);
  };

  getProcessStatusList = (success: any, error: any, returnPara: any) => {
    // @ts-ignore
    this.sendRequest("getProcessStatusList", {}, success, error, returnPara);
  };

  getInitiatorList = (para: any, success: any, error: any, returnPara: any) => {
    // @ts-ignore
    this.sendRequest("getInitiatorList", para, success, error, returnPara);
  };

  getProcedureInfoByProcedureTaskId = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getProcedureInfoByProcedureTaskId", para, success, error);
  };

  getCurrentProcessorFilter = (para: any, success: any, error: any, returnPara: any) => {
    // @ts-ignore
    this.sendRequest("getCurrentProcessorFilter", para, success, error, returnPara);
  };

  getTriggerProcessFilter = (para: any, success: any, error: any, returnPara: any) => {
    // @ts-ignore
    this.sendRequest("getTriggerProcessFilter", para, success, error, returnPara);
  };

  getProcessInitiatorFilter = (para: any, success: any, error: any, returnPara: any) => {
    // @ts-ignore
    this.sendRequest("getProcessInitiatorFilter", para, success, error, returnPara);
  };
}

const changeHistoryService = new ChangeHistoryService();

export default changeHistoryService;
